import { render } from "./CxPointGrid.vue?vue&type=template&id=1f7f3854"
import script from "./CxPointGrid.vue?vue&type=script&lang=js"
export * from "./CxPointGrid.vue?vue&type=script&lang=js"

import "./CxPointGrid.vue?vue&type=style&index=0&id=1f7f3854&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__